import { mockReferralSummary, type ReferralSummary } from '../lib/referral';
import { useSession } from './useSession';

// STUB: no referral backend yet. Derives a personal code from the session and
// returns mock funnel data. Replace the body with a real query (keyed on the
// user) once /api/referrals exists — ReferralSummary is the contract.
export function useReferral(): ReferralSummary | null {
  const session = useSession();
  if (!session) return null;
  // Numeric Telegram id — stable, unlike a username the user can change.
  const code = String(session.user.telegram_id);
  return mockReferralSummary(code);
}
